import { z } from 'zod';
import { PlayerColor } from '../PlayerState.ts';
import { validateState } from '../ValidateState.ts';
export const endGameActivityStateSchema = z.object({
    color: z.enum(PlayerColor),
    proposedTrades: z.number().int().nonnegative(),
    successfulTrades: z.number().int().nonnegative(),
    resourcesUsed: z.number().int().nonnegative(),
    resourceIncomeBlocked: z.number().int().nonnegative(),
    devCardsBought: z.number().int().nonnegative(),
    devCardsUsed: z.number().int().nonnegative()
}).strict();
export function validateEndGameActivityState(data) {
    return validateState(endGameActivityStateSchema, data);
}
